// extracted by mini-css-extract-plugin
module.exports = {"container":"RecentSoldPrices_container__9_eFX"};